import cn from 'classnames';
import { useContext } from 'react';

import Button from 'components/common/Button';
import Subheading from 'components/common/Subheading';
import Text from 'components/common/Text';
import Divider from 'components/icons/Divider';
import PromoTag from 'components/icons/PromoTag';
import { BrandContext, HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import styles from 'styles/components/signUpFunnel/promo/PromoCodeSection';

import PromoCodeForm from './PromoCodeForm';

const PromoCodeSection = ({
  errorMessage = '',
  handleAddVoucherClick,
  handleSecretSaleClick,
  isSubmitting,
}) => {
  const { brand } = useContext(BrandContext);
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <section className={cn(styles.background, styles[brand], styles.validatorBox)}>
      <Subheading
        className="flex justify-center gap-2 pb-4 text-center"
        brandStylesOverrides="h4 text-primary"
      >
        <PromoTag className="mt-1.5" /> Get $10 off!
      </Subheading>
      <Text brandStylesOverrides="textMd" className="pb-3 text-center">
        Sign up for {isHomeChef ? 'Home Chef' : 'Tempo'} today to get $10 off your second order.
        Offer expires in 90 days from sign up date.
      </Text>
      <Button type="button" onClick={handleSecretSaleClick} className="mb-4">
        Get $10 Off Your Second Order
      </Button>
      <div className="flex flex-col items-center text-center">
        <Divider />
        <Text className="mb-2 pt-4" brandStylesOverrides="textSm text-secondary">
          Use a Different Promo Code or Gift Card
        </Text>
        <PromoCodeForm
          handleAddVoucherClick={handleAddVoucherClick}
          errorMessage={errorMessage}
          isSubmitting={isSubmitting}
          buttonClassName="btnOutlineSecondary bg-white-100"
          formFieldClassName="justify-center"
        />
      </div>
    </section>
  );
};

PromoCodeSection.propTypes = {
  errorMessage: PropTypes.string,
  handleAddVoucherClick: PropTypes.func.isRequired,
  handleSecretSaleClick: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default PromoCodeSection;
